import { Formik } from "formik";
import React, { useEffect } from "react";
import { useState, useRef } from "react";
import { isEmpty } from "lodash";
import {
  ManageCensusLayout,
  LoaderWrapper,
  SliderPanel,
  ResponsiveSlideout,
} from "../../../components";
import {
  MANAGE_CENSUS_ROUTES,
  getAdvancedPathWithParam,
  FLOW_TYPES,
  manageCensusFormNames,
  formFields,
} from "../../../utils";
import { Form } from "react-bootstrap";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import {
  getBeneficiaryDetailsByEmployeeId,
  getBeneficiaryDetailsById,
  editBeneficiaryPercentage,
} from "../../../services";
import BeneficiaryTableComponent from "./BeneficiaryTableComponent";
import SetPercentageSlideout from "./SetPercentageSlideout";

const BeneficiaryPercentageSlideOut = ({
  onFormSubmit,
  beneficiaryDetailsData,
  isPercentageOpen,
  setPercentageOpen,
  buttonListForSetPercentage,
  tableError,
  setTableError,
}) => {
  return (
    <Formik
      initialValues={{
        beneficiaryPercentage: beneficiaryDetailsData,
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formikProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          values,
          setValues,
          setTouched,
          setSubmitting,
          resetForm,
          ...rest
        } = formikProps;

        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <ResponsiveSlideout
              resetForm={resetForm}
              slideOutOpen={isPercentageOpen}
              setSlideOutOpen={setPercentageOpen}
              title={"Set Percentage"}
              mobileSlidoutHeight={"100"}
              webSlidoutWidth={"55"}
              buttonList={buttonListForSetPercentage}
              setTableError={setTableError}
            >
              <SetPercentageSlideout
                values={values}
                setFieldValue={setFieldValue}
                title={beneficiaryDetailsData?.[0]?.beneficiaryType}
                handleChange={handleChange}
                data={beneficiaryDetailsData}
                tableError={tableError}
              />
            </ResponsiveSlideout>
          </Form>
        );
      }}
    </Formik>
  );
};
const BeneficiaryDetailsContainer = (props) => {
  const { history } = props;
  const { censusId, flow } = useRouterParams();
  const formName = manageCensusFormNames.BENEFICIARY_DETAILS;
  const fields = formFields[formName];
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  const beneficiaryDetails = useRef([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPercentageOpen, setPercentageOpen] = useState(false);
  const [beneficiaryInfoOpen, setBeneficiaryInfoOpen] = useState(false);
  const [selectedBeneficiaryDetails, setSelectedBeneficiaryDetails] = useState(
    []
  );
  const [getApi, setGetApi] = useState(false);
  const [tableError, setTableError] = useState("");

  const initialValues = {};
  const onFormSubmit = (values) => {};

  useEffect(() => {
    setIsLoading(true);
    getBeneficiaryDetailsByEmployeeId(censusId)
      .then((response) => {
        beneficiaryDetails.current = response;
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [getApi]);

  return (
    <>
      <Formik
        initialValues={{ ...initialValues }}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            ...rest
          } = formProps;

          const buttons = [
            {
              label: "Add Beneficiary",
              variant: "primary",
              type: "button",
              link: getAdvancedPathWithParam({
                path: MANAGE_CENSUS_ROUTES.ADD_BENEFICIARY,
                pathParam: [FLOW_TYPES.ADD, censusId],
              }),
            },
          ];

          const buttonListForSetPercentage = [
            {
              label: "Save",
              variant: "primary",
              type: "submit",
            },
            {
              label: "Cancel",
              //onClick: () => { setTableError('');setPercentageOpen(false);},
              variant: "outline-primary",
            },
          ];
          const primaryBeneficiaryData = beneficiaryDetails.current.filter(
            (ben) => ben.beneficiaryType === "Primary"
          );
          const contingentBeneficiaryData = beneficiaryDetails.current.filter(
            (ben) => ben.beneficiaryType === "Contingent"
          );
          const onFormSubmit1 = (
            values,
            { setFieldError, setFieldTouched }
          ) => {
            var totPercentage = values.beneficiaryPercentage
              .map((x) => x.percentage)
              .reduce((x, a) => x + a, 0);
            setTableError("");
            if (totPercentage !== 100 && totPercentage !== 0) {
              setTableError(
                `Total ${values.beneficiaryPercentage[0].beneficiaryType} Percentage should be 0% or 100% `
              );
              return;
            }
            setPercentageOpen(false);
            editBeneficiaryPercentage(values).then((response) => {
              if (response.isSuccessfull) {
                setPercentageOpen(false);
                setGetApi(!getApi);
              } else {
              }
            });
          };

          return (
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManageCensusLayout
                layoutHeader="Beneficiary Details"
                buttons={buttons}
                pageFlow={flow}
              >
                <div
                  className="w-100 maintenance-container"
                  style={{ paddingRight: "10px" }}
                >
                  <LoaderWrapper isLoading={isLoading}>
                    {beneficiaryDetails == null ? (
                      <p>No Beneficiaries added</p>
                    ) : (
                      <div>
                        <BeneficiaryTableComponent
                          data={primaryBeneficiaryData}
                          title={"Primary"}
                          setPercentageOpen={setPercentageOpen}
                          censusId={censusId}
                          setSelectedBeneficiaryDetails={
                            setSelectedBeneficiaryDetails
                          }
                          history={history}
                        />
                        <BeneficiaryTableComponent
                          data={contingentBeneficiaryData}
                          title={"Contingent"}
                          setPercentageOpen={setPercentageOpen}
                          censusId={censusId}
                          setSelectedBeneficiaryDetails={
                            setSelectedBeneficiaryDetails
                          }
                          history={history}
                        />
                        <BeneficiaryPercentageSlideOut
                          onFormSubmit={onFormSubmit1}
                          beneficiaryDetailsData={selectedBeneficiaryDetails}
                          buttonListForSetPercentage={
                            buttonListForSetPercentage
                          }
                          isPercentageOpen={isPercentageOpen}
                          setPercentageOpen={setPercentageOpen}
                          tableError={tableError}
                          setTableError={setTableError}
                        />
                      </div>
                    )}
                  </LoaderWrapper>
                </div>
              </ManageCensusLayout>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default BeneficiaryDetailsContainer;
